import { trackingAxios } from './base';

export const trackingAction = !!window?.navigator?.sendBeacon
  ? (param: any) => {
      window.navigator.sendBeacon(
        `${process.env.REACT_APP_API_URI}/events/v1/receive`,
        JSON.stringify(param),
      );
    }
  : (params: any) => {
      return trackingAxios.post(`/events/v1/receive`, params);
    };
